/**
 * Canonical versions of Proporio's legal documents — frontend mirror of the
 * backend `backend/functions/src/legal/legalVersions.ts`. Keep the two in
 * sync: the consent step sends these versions, and `recordUserConsent`
 * rejects them unless they match the backend's current values.
 *
 * The version string is the document's effective date (ISO `yyyy-mm-dd`).
 * Bumping a value here (after editing the matching `assets/legal/*.md`)
 * makes existing consents stale and triggers the blocking re-consent modal.
 */
export const LEGAL_VERSIONS = {
  terms: '2026-06-06',
  privacy: '2026-06-06',
} as const;

export type LegalDocumentType = keyof typeof LEGAL_VERSIONS;
